import { Instance, SnapshotIn, SnapshotOut, types } from 'mobx-state-tree';
import { IUserImageAreaModel } from './userImageArea';
import { PreviewModel, ViewBoxModel } from './preview';
import { IViewBox } from '@photosi/expo-photosi-sdk/build/ViewBox';
import { Orientation } from '@photosi/expo-photosi-sdk/build/UserImage';
import { ProductCategoryCode } from '@photosi/expo-photosi-sdk/build/Product';

export type TPreviewPrintModel = typeof PreviewPrintModel;
export type PreviewPrintModelInstance = Instance<TPreviewPrintModel>;
export interface IPreviewPrintModelIn extends SnapshotIn<TPreviewPrintModel> {}
export interface IPreviewPrintModelOut extends SnapshotOut<TPreviewPrintModel> {}
export interface IPreviewPrintModel extends PreviewPrintModelInstance {}

export const PreviewPrintModel = PreviewModel.named('PreviewPrintModel')
  .props({
    type: types.union(
      types.literal(ProductCategoryCode.SMALL_SIZE),
      types.literal(ProductCategoryCode.LARGE_SIZE),
      types.literal(ProductCategoryCode.SMALL_SIZE_WITH_BORDER),
      types.literal(ProductCategoryCode.PANORAMIC_SIZE),
    ),
    verticalViewBox: ViewBoxModel,
    horizontalViewBox: ViewBoxModel,
    verticalBackgroundViewBox: ViewBoxModel,
    horizontalBackgroundViewBox: ViewBoxModel,
  })
  .views(self => ({
    get innerHorizontalUserImageArea(): IUserImageAreaModel {
      return <IUserImageAreaModel>self.userImageAreas.find(userImageArea => userImageArea.id === 'userImageAreaH');
    },
    get innerVerticalUserImageArea(): IUserImageAreaModel {
      return <IUserImageAreaModel>self.userImageAreas.find(userImageArea => userImageArea.id === 'userImageAreaV');
    },
  }))
  .views(self => ({
    get currentUserImage() {
      return self.innerVerticalUserImageArea.userImage ?? self.innerHorizontalUserImageArea.userImage;
    },
  }))
  .views(self => ({
    get isMultiphoto(): boolean {
      return false;
    },
    get userImageArea(): IUserImageAreaModel {
      // const currentUserImage = self.innerVerticalUserImageArea.userImage ?? self.innerHorizontalUserImageArea.userImage;
      if (self.currentUserImage?.orientation === Orientation.VERTICAL) {
        return self.innerVerticalUserImageArea;
      } else {
        return self.innerHorizontalUserImageArea;
      }
    },
    get viewBox(): IViewBox {
      // const currentUserImage = self.innerVerticalUserImageArea.userImage ?? self.innerHorizontalUserImageArea.userImage;
      if (self.currentUserImage?.orientation === Orientation.VERTICAL) {
        return self.verticalViewBox;
      } else {
        return self.horizontalViewBox;
      }
    },
    get backgroundViewBox(): IViewBox {
      // const currentUserImage = self.innerVerticalUserImageArea.userImage ?? self.innerHorizontalUserImageArea.userImage;
      if (self.currentUserImage?.orientation === Orientation.VERTICAL) {
        return self.verticalBackgroundViewBox;
      } else {
        return self.horizontalBackgroundViewBox;
      }
    },
    get backgroundColor(): string | undefined {
      // const currentUserImage = self.innerVerticalUserImageArea.userImage ?? self.innerHorizontalUserImageArea.userImage;
      return self.currentUserImage?.backgroundColor;
    },
  }))
  .views(self => ({
    get hasBorder(): boolean {
      return !(
        self.userImageArea.x === self.backgroundViewBox.x &&
        self.userImageArea.y === self.backgroundViewBox.y &&
        self.userImageArea.width === self.backgroundViewBox.width &&
        self.userImageArea.height === self.backgroundViewBox.height
      );
    },
  }));
